<div class="container-fluid">

    <div class="d-flex  mt-2 row">

        <mat-form-field appearance="outline" class="col-md-3">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate [(ngModel)]="start" placeholder="Start date">
                <input matEndDate [(ngModel)]="end" placeholder="End date">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

            <!--            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>-->
            <!--            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>-->

        </mat-form-field>
<!--        <mat-form-field appearance="outline" class="col-md-3">-->
<!--            <mat-label>Centres</mat-label>-->
<!--            <mat-select [formControl]="centreControl" [(ngModel)]="selectedCentre">-->
<!--                <mat-option *ngFor="let c of (_centres$|async)" [value]="c.centreCode">{{c.centreName}} </mat-option>-->
<!--                <mat-option value="All">All Centres</mat-option>-->

<!--            </mat-select>-->
<!--        </mat-form-field>-->

<!--      <app-searchable-select-->
<!--        class="col-md-4"-->
<!--        [options]="_centres$ | async"-->
<!--        [selectedValue]="selectedCentre"-->
<!--        [displayWithFn]="displayType"-->
<!--        [label]="'Select Centres'"-->
<!--        [placeholder]="'All Centres'"-->
<!--        (selectionChange)="onTypeSelect($event)"-->
<!--      ></app-searchable-select>-->

      <app-searchable-select
        class="col-md-4"
        [options]="_centres$ | async"
        [multiple]="true"
        [hideSelectAllOption]="false"
        [selectedValue]="selectedCentreObj"
        [displayWithFn]="displayType"
        [displayKey]="'centreName'"
        [valueKey]="'centreCode'"
        [label]="'Select Centres'"
        [placeholder]="'All Centres'"
        (selectionChange)="onCentreChange($event)">
      </app-searchable-select>



      <div class="col-md-4">
        <button mat-mini-fab (click)="dynamicSearch()" color="accent">
            <mat-icon>search</mat-icon>
        </button>&nbsp;

        <button mat-mini-fab (click)="clearAll()" color="accent">
            <mat-icon>clear</mat-icon>
        </button>

      </div>

        <mat-form-field appearance="outline" class="col-md-3" >
            <mat-label>Session Type</mat-label>
            <mat-select [(ngModel)]="sessionType" (selectionChange)="applyfilters()" >
                <mat-option value='All'>All Sessions</mat-option>
                <mat-option *ngFor="let t of sessionTypes" [value]="t">{{t}}</mat-option>
            </mat-select>
        </mat-form-field>
<!--        <mat-form-field appearance="outline" class="col-md-3" >-->
<!--            <mat-label>Submitted By</mat-label>-->
<!--            <mat-select [(ngModel)]="submittedBy"  >-->
<!--                <mat-option value='All'> All Counsellors </mat-option>-->
<!--                <mat-option *ngFor="let e of counsellors$|async" [value]="e.userName">{{e.userName}}</mat-option>-->
<!--            </mat-select>-->
<!--        </mat-form-field>-->

<!--      <app-searchable-select-->
<!--        class="col-md-4"-->
<!--        [options]="counsellors$ | async"-->
<!--        [selectedValue]="submittedBy"-->
<!--        [displayWithFn]="displaysubmittedBy"-->
<!--        [label]="'Submitted By'"-->
<!--        [placeholder]="'All Counsellors'"-->
<!--        (selectionChange)="onTypeSelect($event)"-->
<!--      ></app-searchable-select>-->

      <app-searchable-select
        class="col-md-4"
        [options]="counsellors$ | async"
        [selectedValue]="submittedByObj"
        [displayWithFn]="displaysubmittedBy"
        [label]="'Submitted By'"
        [placeholder]="'All Counsellors'"
        (selectionChange)="onSubmittedByChange($event)">
      </app-searchable-select>


    </div>



  <h4>Note : To rearrange the order of loaded data, click on the column title. It will perform ascending and descending sorting for that column.</h4>

  <div class="card p-2">
        <div class="ngxTableHeader">
            <ul class="header-buttons-left ms-0 mb-0">
                <li class="dropdown">
                    <h2>Counselling Individual Sessions</h2>
                </li>
                <li class="dropdown m-l-20">
                    <label id="search-input"><i class="material-icons search-icon">search</i></label>
                    <input placeholder="Search" type="text" class="browser-default search-field"
                           (keyup)='applyFilter($event)' aria-label="Search box" #input>
                </li>
            </ul>

            <ul class="header-buttons mr-2">
                <li class="me-2">
                  <button permission="Individual Sessions"
                          [permissionTypes]="[PermissionType.ADD, PermissionType.EDIT]"

                          mat-mini-fab color="primary"
                          (click)="openIndividualSessionDialog()">
                    <mat-icon class="col-white">add</mat-icon>
                  </button>

                </li>


              <li>
                <button
                  mat-mini-fab color="accent"
                  (click)="downloadExcel()">
                  <mat-icon>download</mat-icon>
                </button>

              </li>


              <!--      <li>-->
                <!--        <div class="export-button m-l-10" matTooltip="XLSX">-->
                <!--          <img src="assets/images/icons/xlsx.png" alt=""/>-->
                <!--        </div>-->
                <!--      </li>-->
            </ul>
        </div>
      <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>
        <!--------------------------------------------- TABLE --------------------------------------------->
        <table mat-table [dataSource]="dataSource" class="example-container  table" matSort>

            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->


          <ng-container matColumnDef="sr.no">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sr.No.</th>
            <td mat-cell *matCellDef="let element; let i =index" class="truncate-text" [matTooltip]="element.id" matTooltipPosition="above" > {{i+1}} </td>
          </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="childName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Child Name</th>
                <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.id" matTooltipPosition="above" > {{element.childName}} </td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.type" matTooltipPosition="above"> {{element.type}} </td>
            </ng-container>
            <ng-container matColumnDef="childCode">
                <th mat-header-cell *matHeaderCellDef  mat-sort-header> Child Code</th>
                <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.childCode" matTooltipPosition="above"> {{element.childCode}} </td>
            </ng-container>
            <!-- Weight Column -->
            <ng-container matColumnDef="centreName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre Name</th>
                <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.centreName" matTooltipPosition="above"> {{element.centreName}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Date</th>
                <td mat-cell *matCellDef="let element" class="truncate-text" > {{getDate(element.date)}} </td>
            </ng-container>
            <!-- Position Column -->
            <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>CreatedAt</th>

                <td mat-cell *matCellDef="let element" class="truncate-text"><span
                        *ngIf='element.createdAt'>{{element?.createdAt|date:'dd/MM/yyyy' }}</span></td>

            </ng-container>
            <!-- Position Column -->
            <ng-container matColumnDef="submittedBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Submitted By</th>

                <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.submittedBy">  {{element?.submittedBy }} </td>

            </ng-container>
            <!-- Position Column -->
            <ng-container matColumnDef="challengesFaced">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="truncate-text">Challenges Faced</th>

                <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.challengesFaced"><span>{{element?.challengesFaced }}</span></td>

            </ng-container>
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element" class="d-flex">
                  <button  mat-icon-button [color]="element.isHighlight ? 'warn' : 'accent'" (click)="toggleHighlight(element)" [matTooltip]="element.isHighlight ? 'Remove Highlight' : 'Highlight Session'">
                    <mat-icon>{{element.isHighlight ? 'star' : 'star_border'}}</mat-icon>
                  </button>

                    <button permission="Individual Sessions"
                            [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]" mat-icon-button color="accent"
                            matTooltip="View" (click)="viewDialog(element)">
                        <mat-icon>remove_red_eye</mat-icon>
                    </button>
                    <button  mat-icon-button
                            color="primary" matTooltip="Edit" permission="Individual Sessions"
                             *ngIf="editAccess(element)"
                             [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]" (click)="viewEdit(element)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button *ngIf="editAccess(element)" permission="Individual Sessions"
                            [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]"  mat-icon-button color="warn"
                            (click)="delete(element)" matTooltip="Delete">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4"><span *ngIf="selectedCentre==''"> No Centre Selected</span>
                    <span *ngIf="selectedCentre!=''">No data matching the filter "{{input.value}}"</span></td>
            </tr>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


        </table>
        <mat-paginator [pageSizeOptions]="[25, 50,100,200]"
                       showFirstLastButtons
                       aria-label="Select page of periodic elements">
        </mat-paginator>

    </div>
</div>


<!--------------------------------------------- TABLE --------------------------------------------->

